// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"oz_a bhu_px bhu_a bhu_w","FaqAskQuestion__outdated":"oz_b bhu_ul bhu_vz"};